<div fxLayout="row wrap">
    <div fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
        <mat-card>
            <mat-card-content>
                <div fxLayout="row wrap">
                    <div fxFlex.gt-lg="70" fxFlex.gt-md="70" fxFlex.gt-xs="100" fxFlex="100">
                        <mat-card-title class="m-l-0 m-t-10">Overview :</mat-card-title>
                    </div>

                    <div fxFlex.gt-lg="30" fxFlex.gt-md="30" fxFlex.gt-xs="100" fxFlex="100">
                        <mat-card-title style="cursor: pointer;" class="text-right">
                            <button mat-stroked-button (click)="addDialog()" color="" id=""
                                class=" bg-danger text-white">BCR</button>
                        </mat-card-title>
                    </div>
                </div>
                
                <div class="p-5 m-t-20 p-r-20 p-l-20" style="background-color: aliceblue;">
                    <mat-form-field>
                        <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Search">
                    </mat-form-field>
                </div>

                <div class="table-responsive">
                    <table mat-table [dataSource]="dataSource" matSort class="no-wraap m-t-10 v-middle"
                        style="width: 100%;">
                        <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-medium font-16 p-15">
                                BCR Month </th>
                            <td mat-cell *matCellDef="let row" class="p-15 font-normal"> February 2022 </td>
                        </ng-container>

                        <ng-container matColumnDef="progress">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-medium font-16 p-15">
                                BCR Amount </th>
                            <td mat-cell *matCellDef="let row" class="p-15 font-normal text-right"> 75.46 </td>
                        </ng-container>

                        <ng-container matColumnDef="accountm">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-medium font-16 p-15">
                                Content Earning Adjustment </th>
                            <td mat-cell *matCellDef="let row" class="p-15 font-normal text-right"> 0.00 </td>
                        </ng-container>

                        <ng-container matColumnDef="color">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-medium font-16 p-15">
                                Video Earning Adjustment</th>
                            <td mat-cell *matCellDef="let row" class="p-15 font-normal text-right"> 0.00 </td>
                        </ng-container>

                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-medium font-16 p-15">
                                Network Partner Adjustment</th>
                            <td mat-cell *matCellDef="let row" class="p-15 font-normal text-right"> No Data </td>
                        </ng-container>

                        <ng-container matColumnDef="earning">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-medium font-16 p-15">
                                Minimum Revenue for Adjustment</th>
                            <td mat-cell *matCellDef="let row" class="p-15 font-normal text-right"> No Data </td>
                        </ng-container>

                        <ng-container matColumnDef="np">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-medium font-16 p-15">
                                Total Network Partner for Adjustment</th>
                            <td mat-cell *matCellDef="let row" class="p-15 font-normal text-right"> No Data </td>
                        </ng-container>

                        <ng-container matColumnDef="bcrdate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-medium font-16 p-15">
                                BCR Created Date</th>
                            <td mat-cell *matCellDef="let row" class="p-15 font-normal"> 21 Mar, 2022 </td>
                        </ng-container>

                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef class="font-medium font-16 p-20"> Action </th>
                            <td mat-cell *matCellDef="let element" class="p-20 font-normal text-center action-link">
                                <a  (click)="editDialog()" matTooltip="View / Update BCR information"
                                    class="m-r-20 cursor-pointer">
                                    <i class="fa fa-pencil font-20 text-danger networkpartner-mobile"></i>
                                </a>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;">
                        </tr>
                    </table>

                    <mat-paginator [pageSizeOptions]="[10, 25, 100]"></mat-paginator>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>